import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { searchHolders, addEditHolder, deleteHolder } from "../store/api/GuaranteeApi";
import { Fragment, useEffect, useState } from "react";
import { setDialog } from "../store/api/GetAllProduct";
import { CheckLg, DashCircle, Pencil, PencilFill, PlusSquareFill } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListAlt, faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalGuaranteeHolders = (props) => {
    const dispatch = useDispatch();
    const [dataList, setDataList] = useState(null);
    const { popData, setPopData } = props;
    const { show } = popData;
    const [currentHolder, setCurrentHolder] = useState(null);
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "نام برند", colName: "HolderName", justInMobile: true },
        { colTitle: "فعال", colName: "IsActive", justInMobile: true, colType: "boolean" },
        { colTitle: "نوع", colName: "HolderTypeStr" }
    ]
    const rowButtons = [
        { title: "ویرایش", type: "common", icon: <PencilFill size={18} color="orange" />, onclick: selectRow },
        {
            title: "حذف برند", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف برند',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteH(item.ID)
                }))
            }
        }
    ]
    function selectRow(row) {
        if(currentHolder)
        {
            return;
        }
        delete row.e;
        setCurrentHolder(row);
    }
    function deleteH(id) {
        const onDelete = (res) => {
            if (res.Data) {
                getList();
            }
        }
        deleteHolder(id, onDelete);
    }
    function getList() {
        const onGetList = (res) => {
            if (res.Data) {
                setDataList(res);
            }
        }
        searchHolders("", "", onGetList);
    }
    function prepareForAdd() {
        setCurrentHolder({
            ID: 0
        })
    }
    function submitData() {
        if (!currentHolder.HolderName || isNaN(currentHolder.HolderType)) {
            return;
        }
        if (currentHolder.IsActive === undefined) {
            currentHolder.IsActive = true;
        }
        const onAddEdit = (res)=>{
            if(res.Data)
            {
                getList();
                setCurrentHolder(null);
            }
        }
        addEditHolder(currentHolder, onAddEdit);
    }
    function cancelData() {
        setCurrentHolder(null);
    }
    function close() {
        setCurrentHolder(null);
        setPopData({ show: false });
    }
    useEffect(() => {
        if (show) {
            getList();
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faListAlt} size="lg" />&nbsp;
                    مدیریت برندها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {currentHolder &&
                    <Row className="rowBorder">
                        <Col md={6} className="form-group">
                            <label>نوع برند: </label>
                            <select className="form-control" defaultValue={currentHolder.HolderType ?? ""} onChange={e => currentHolder.HolderType = e.target.value}>
                                <option value="">انتخاب کنید</option>
                                <option value={0}>گارانتی کننده</option>
                                <option value={1}>تولید کننده</option>
                            </select>
                        </Col>
                        <Col md={6} className="form-group">
                            <label>نام برند: </label>
                            <Form.Control defaultValue={currentHolder?.HolderName ?? ""} onChange={e => currentHolder.HolderName = e.target.value} />
                        </Col>
                        <Col md={6}  className="form-group">
                            <input type="checkbox" className="form-check-input" defaultChecked={currentHolder.UseCardsBeforeActivation ?? false}
                                onChange={e => currentHolder.UseCardsBeforeActivation = e.target.checked} />&nbsp;
                            <label  className="mt-1">استفاده پیش از فروش</label>
                        </Col>
                        <Col md={6}  className="form-group">

                            <input type="checkbox" className="form-check-input" defaultChecked={currentHolder.IsActive ?? false}
                                onChange={e => currentHolder.IsActive = e.target.checked} />&nbsp;
                            <label className="mt-1">فعال</label>
                        </Col>
                        <div className="mt-1">
                            <Button className="group-Btn" onClick={submitData}>
                                {Number(currentHolder.ID) > 0 ?
                                    <Fragment>
                                        <Pencil size={16} />&nbsp; ویرایش
                                    </Fragment> :
                                    <Fragment>
                                        <CheckLg size={16} />&nbsp; ثبت
                                    </Fragment>}
                            </Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelData}>
                                <DashCircle size={16} />&nbsp;
                                انصراف
                            </Button>
                        </div>
                    </Row>

                }
                {!currentHolder &&
                    <PlusSquareFill size={25} onClick={prepareForAdd} color="#4f4fb7" className="hoverIcon"/>}
                <BihamtaTable rowButtons={rowButtons} columns={tableCols} fixedTable dataList={dataList} />
            </Modal.Body>
        </Modal>
    )

}
export default ModalGuaranteeHolders;